export const SortListMyImagesPage = ["Newest → Oldest", "Oldest → Newest", "Most Favorites"];
export const SortListHomePage = ["Newest → Oldest", "Oldest → Newest", "Most Favorites"];
